// Hooks split out of I18nProvider so the provider file exports only a
// component (keeps Vite fast-refresh happy).

import { useContext } from 'react';
import { I18nContext } from './I18nContext';
import type { I18nContextValue } from './I18nContext';

export function useI18n(): I18nContextValue {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used inside <I18nProvider>');
  return ctx;
}

export function useT(): I18nContextValue['t'] {
  return useI18n().t;
}
